import React, { Component } from 'react'

import { Card,CardDuration,ButtonContainer, InvestorsInfoContainer, CardContainerLink,DownloadIcon, CardIcon, IconTextContainer } from './styledComponent'
import { ResponsiveContainer } from '../styledComponent'

interface Props{
    tabCorporateGovernanceActive:boolean
}

export default class InvestorsInfoSection extends Component<Props> {
    render() {
        const {tabCorporateGovernanceActive}=this.props
        return (
    <ResponsiveContainer>
        <InvestorsInfoContainer>
           {tabCorporateGovernanceActive && 
            <>
           <CardContainerLink>
                <a href="/assets/investor-relations/Notice_2019-20.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>AGM Notice 2019-20</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Notice2019-20.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
             <CardContainerLink>
                <a href="/assets/investor-relations/Scrutinizer_Report_2019-20.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Scrutinizer Report 2019-20</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/ScrutinizerReport_2019-20.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
<CardContainerLink>
                <a href="/assets/investor-relations/Newspaper_Ad_AGM_Notice.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Newspaper Ad AGM Notice</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Newspaper_Ad_AGM_Notice.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            <CardContainerLink>     
                <a href="/assets/investor-relations/Newspaper_Ad_for_VC_AGM.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Newspaper Ad for VC AGM</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Newspaper_Ad_for_VC_AGM.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            <CardContainerLink>
                <a href="/assets/investor-relations/Transcript_of_03rd_AGM.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Transcript of 03rd AGM</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Transcript_of_03rd_AGM.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            <CardContainerLink>
                <a href="/assets/investor-relations/Vernacular_Newspaper_Ad_AGM_Notice.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Vernacular Newspaper Ad AGM Notice</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Vernacular_Newspaper_Ad_AGM_Notice.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            <CardContainerLink>
                <a href="/assets/investor-relations/Vernacular_Newspaper_AD_for_VC_AGM.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Vernacular Newspaper Ad for VC AGM</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/Vernacular_Newspaper_AD_for_VC_AGM.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            </>
            }
          {!tabCorporateGovernanceActive&&  <CardContainerLink>
                <a href="/assets/investor-relations/Annual_Report_2019-20.pdf" target="_blank">
                    <Card>
                        <IconTextContainer>
                            <CardIcon src="/assets/images/card_icon.png"/>
                            <CardDuration>Annual Report 2019-20</CardDuration>
                        </IconTextContainer>
                        <ButtonContainer href="/assets/investor-relations/AnnualReport2019-20.pdf" download>
                            <DownloadIcon />
                        </ButtonContainer>   
                    </Card>
                </a>
            </CardContainerLink>
            }
        </InvestorsInfoContainer>
    </ResponsiveContainer>
        )
    }
}
